export default "__VITE_ASSET__DdYyuQQv__"